import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PartnersComponent } from './partners.component';

const routes: Routes = [
  {
    path: '',
    component: PartnersComponent,
    children: [
      {
        path: 'affiliates',
        loadChildren: () => import('./affiliates/affiliates.module').then(m => m.AffiliatesModule),
      },
      {
        path: 'real-estate-professionals',
        loadChildren: () => import('./real-estate-professionals/real-estate-professionals.module').then(m => m.RealEstateProfessionalsModule),
      },
      {
        path: 'service-providers',
        loadChildren: () => import('./service-providers/service-providers.module').then(m => m.ServiceProvidersModule),
      },
      {
        path: 'suppliers',
        loadChildren: () => import('./suppliers/suppliers.module').then(m => m.SuppliersModule),
      },
      {
        path: 'title-agencies',
        loadChildren: () => import('./title-agencies/title-agencies.module').then(m => m.TitleAgenciesModule),
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PartnersRoutingModule { }
